/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_themeBase/_helpers";
import * as actions from "../../../../app/actions/generalActions";

import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../../../_themeBase/_partials/dropdowns";

export function ProfileCard() {
  // const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const [pic, setPic] = useState("");
  const { user } = useSelector(
    (state) => ({ user: state.auth.user }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (user && user.imageFileDescriptionId) {
      dispatch(actions.downloadImage("api/FileManagement", "user", user.imageFileDescriptionId
      ))
    }
    else {
      setPic("")
    }
  }, [user]);


  const getUserPic = () => {
    if (!pic) {
      return `url(${toAbsoluteUrl(
        "/media/users/blank.png"
      )})`;
    }
    return `url(${pic})`;
  };

  return (
    <>
      {user && (
        <div
          // className="flex-row-auto offcanvas-mobile w-250px w-xxl-350px"
          className="flex-row mr-1"
          id="kt_profile_aside"
        >
          <div className="card card-custom card-stretch">
            {/* begin::Body */}
            <div className="card-body pt-4">
              {/* begin::Toolbar */}
              {/* <div className="d-flex justify-content-end">
              <Dropdown className="dropdown dropdown-inline" alignRight>
                <Dropdown.Toggle
                  className="btn btn-clean btn-hover-light-primary btn-sm btn-icon cursor-pointer"
                  variant="transparent"
                  id="dropdown-toggle-top-user-profile"
                  as={DropdownCustomToggler}
                >
                  <i className="ki ki-bold-more-hor"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                  <DropdownMenu4></DropdownMenu4>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
              {/* end::Toolbar */}
              {/* begin::User */}
              <div className="d-flex align-items-center">
                <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                  <div
                    className="symbol-label"
                    style={{ backgroundImage: `${getUserPic()}` }}
                  ></div>
                  <i className="symbol-badge bg-success"></i>
                </div>
                <div>
                  <a
                    href="#"
                    className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                  >
                    {user.firstName} {user.lastName}
                    <br></br>
                    {user.roleTitle}
                  </a>
                  {/* <div className="text-muted">{user.occupation}</div> */}
                  {/* <div className="mt-2">
                  <a
                    href="#"
                    className="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                  >
                    Chat
                  </a>
                  <a
                    href="#"
                    className="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                  >
                    Follow
                  </a>
                </div> */}
                </div>
              </div>
              {/* end::User */}
              {/* begin::Contact */}
              <div className="py-9">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="font-weight-bold mr-2">گروه و زیرگروه:</span>
                  <span className="text-muted text-hover-primary">
                    {user.groupTitle}&nbsp;{user.subGroupTitle}
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="font-weight-bold mr-2">شماره شناسایی:</span>
                  <span className="text-muted"> {user.idNumber}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="font-weight-bold mr-2">شماره همراه:</span>
                  <span className="text-muted">{user.mobile}</span>
                </div>
              </div>
              {/* end::Contact */}
              {/* begin::Nav */}
              <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                {/* <div className="navi-item mb-2">
                <NavLink
                  to="/user-profile/profile-overview"
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Design/Layers.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                    پروفایل من
                  </span>
                </NavLink>
              </div> */}

                {/* <div className="navi-item mb-2">
                <NavLink
                  to="/user-profile/personal-information"
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/User.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                   اطلاعات پایه
                  </span>
                </NavLink>
              </div> */}


                <div className="navi-item mb-2">
                  <NavLink
                    to="/user-profile/change-password"
                    className="navi-link py-4"
                    activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Shield-user.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      تغییر رمز عبور
                    </span>
                    {/* <span className="navi-label">
                    <span className="label label-light-danger label-rounded font-weight-bold">
                      5
                    </span>
                  </span> */}
                  </NavLink>
                </div>

                <div className="navi-item mb-2">
                  <NavLink
                    to="/user-profile/change-mobile"
                    className="navi-link py-4"
                    activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Call.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      ویرایش شماره همراه
                    </span>
                  </NavLink>
                </div>

                <div className="navi-item mb-2">
                  <NavLink
                    to="/user-profile/payment"
                    className="navi-link py-4"
                    activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Wallet.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      افزایش اعتبار
                    </span>
                  </NavLink>
                </div>

                <div className="navi-item mb-2">
                  <NavLink
                    to="/user-profile/personal"
                    className="navi-link py-4"
                    activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/User.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      ویرایش اطلاعات و مدارک
                    </span>
                  </NavLink>
                </div>

                <div className="navi-item mb-2">
                  <NavLink
                    to="/user-profile/ranking"
                    className="navi-link py-4"
                    activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Money.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      امتیازات من
                    </span>
                  </NavLink>
                </div>

                {/* <div className="navi-item mb-2">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>Coming soon...</Tooltip>}
                >
                  <a href="#" className="navi-link py-4">
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Layout/Layout-top-panel-6.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      Saved Credit Cards
                    </span>
                  </a>
                </OverlayTrigger>
              </div>
              <div className="navi-item mb-2">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>Coming soon...</Tooltip>}
                >
                  <a href="#" className="navi-link py-4">
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Files/File.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      Tax information
                    </span>
                    <span className="navi-label">
                      <span className="label label-light-primary label-inline font-weight-bold">
                        new
                      </span>
                    </span>
                  </a>
                </OverlayTrigger>
              </div>
              <div className="navi-item mb-2">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>Coming soon...</Tooltip>}
                >
                  <a href="#" className="navi-link py-4">
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Text/Article.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text">Statements</span>
                  </a>
                </OverlayTrigger>
              </div> */}
              </div>
              {/* end::Nav */}
            </div>
            {/* end::Body */}
          </div>
        </div>
      )}
    </>
  );
}
